import axios from 'axios';
import { FAILURE, REQUEST, SUCCESS } from 'app/shared/reducers/action-type.util';
import { IWallet } from '../model/user.model';

export const ACTION_TYPES = {
  GET_WALLETS: 'account/GET_WALLETS',
};

// const AUTH_TOKEN_KEY = 'jhi-authenticationToken';

const initialState = {
  loading: false,
  wallets: [] as IWallet[],
  errorMessage: (null as unknown) as string, // Errors returned from server side
  fetchSuccess: false,
  fetchError: false,
};

export type WalletState = Readonly<typeof initialState>;

// Reducer

export default (state: WalletState = initialState, action): WalletState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.GET_WALLETS):
      return {
        ...state,
        loading: true,
      };

    case FAILURE(ACTION_TYPES.GET_WALLETS):
      return {
        ...state,
        loading: false,
        fetchSuccess: false,
        fetchError: true,
        errorMessage: action.payload,
      };

    case SUCCESS(ACTION_TYPES.GET_WALLETS):
      return {
        ...state,
        loading: false,
        fetchSuccess: true,
        fetchError: false,
        wallets: action.payload.data,
      };

    default:
      return state;
  }
};

export const getWallets: (login: string) => void = login => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.GET_WALLETS,
    payload: axios.get(`api/wallets/${login}`),
    meta: 'HIDE_NOTIFICATIONS',
  });
};
